import { Link } from "react-router-dom";
import { categories } from "@/mocks/gossip";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:pr-6">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-chat-smile-3-fill text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">91吃瓜网</span>
            </div>
            <p className="mt-4 font-label text-sm leading-relaxed text-background-300">
              只做信息梳理，不做主观定性。把散落的瓜料按时间线、前因后果与关系图重新排好，让你吃瓜吃透。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-900 text-background-200">
                <i className="ri-mail-line text-base"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-900 text-background-200">
                <i className="ri-share-forward-line text-base"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-900 text-background-200">
                <i className="ri-bookmark-line text-base"></i>
              </span>
            </div>
          </div>

          <nav aria-label="站内导航">
            <h4 className="font-label text-sm tracking-widest text-accent-300 mb-4">站内导航</h4>
            <ul className="space-y-2.5 font-label text-sm">
              <li><Link to="/" className="text-background-300 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/events" className="text-background-300 hover:text-background-50 transition-colors cursor-pointer">复盘档案</Link></li>
              <li><Link to="/about" className="text-background-300 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="text-background-300 hover:text-background-50 transition-colors cursor-pointer">内容原则</Link></li>
            </ul>
          </nav>

          <nav aria-label="主题分类">
            <h4 className="font-label text-sm tracking-widest text-accent-300 mb-4">主题分类</h4>
            <ul className="space-y-2.5 font-label text-sm">
              {categories.slice(0, 5).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="font-label text-sm tracking-widest text-accent-300 mb-4">联系我们</h4>
            <p className="font-label text-sm text-background-300 leading-relaxed">
              内容纠错、线索提供或合作咨询，欢迎发送邮件。我们会在三个工作日内回复。
            </p>
            <a
              href="mailto:contact@91chigua-daily.example"
              className="mt-3 inline-flex items-center gap-2 font-label text-sm text-background-50 hover:text-accent-300 transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              contact@91chigua-daily.example
            </a>
            <p className="mt-3 font-label text-xs text-background-400 leading-relaxed">
              本站人物与事件均为示例内容，仅用于展示信息整理方式。
            </p>
          </div>
        </div>

        <div className="mt-12 border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-label text-xs text-background-400">
            © {year} 91吃瓜网 · 深扒档案室 · 内容仅供信息整理参考
          </p>
          <p className="font-label text-xs text-background-400 flex items-center gap-2">
            <i className="ri-shield-check-line"></i>
            所有线索标注来源与可信度等级
          </p>
        </div>
      </div>
    </footer>
  );
}